export default "/backend/static/media/login_fail.6fed8a17.png";